import type { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/core/macro";

import type { FindingCode } from "@/features/analysis";

// Короткое название находки для «Что находим в разборах» — для команды, не для игрока.
// Оценок метрик (`metric`) в списке нет: бэкенд их не присылает.
export const FINDING_LABELS: Record<Exclude<FindingCode, "metric">, MessageDescriptor> = {
  item_bought_late: msg`Item bought late`,
  core_item_missing: msg`Core item missing`,
  off_build_early: msg`Early buys off the build`,
  item_sold_soon: msg`Item sold right away`,
  no_anti_heal: msg`No anti-heal`,
  defense_mismatch: msg`Defense against the wrong damage`,
  core_items_on_time: msg`Core items on time`,
  lane_result: msg`Lane result`,
  killed_by_hero: msg`Main killer`,
  died_outnumbered: msg`Died outnumbered`,
  died_alone: msg`Died alone`,
  lane_ganked: msg`Ganked on lane`,
  costly_death: msg`Costly death`,
  killed_by_objective: msg`Killed by an objective`,
  low_hp_survival: msg`Survived on low health`,
  enemy_escaped: msg`Enemy got away`,
  missed_teamfight: msg`Missed a teamfight`,
  multi_kill: msg`Multi-kill`,
};

// Название находки по коду; новый код, которого фронт ещё не знает, — сам код.
export const findingLabel = (code: string): MessageDescriptor | string =>
  code in FINDING_LABELS ? FINDING_LABELS[code as keyof typeof FINDING_LABELS] : code;
